import { escapeHtml } from "@emkit/builder-core";
export const TIMELINE_DEFAULTS = {
    events: [
        {
            id: "e1",
            date: "2023 Q1",
            title: "Founded",
            description: "Assembled the founding team and shipped the first prototype.",
        },
        {
            id: "e2",
            date: "2023 Q3",
            title: "Public beta",
            description: "Opened EmBuilder to early users. Collected 1,000+ waitlist signups.",
        },
        {
            id: "e3",
            date: "2024 Q1",
            title: "Seed round",
            description: "Raised a seed round to accelerate core development.",
        },
        {
            id: "e4",
            date: "2024 Q4",
            title: "General availability",
            description: "Shipped v1.0 with full widget catalogue and EmDash integration.",
        },
    ],
    align: "left",
    accent: "#111827",
    textColor: "#0f172a",
    background: "transparent",
    cardBackground: "#ffffff",
};
export const timelineWidget = {
    type: "timeline",
    defaultProps: TIMELINE_DEFAULTS,
    renderHtml(props) {
        const events = props.events ?? [];
        if (events.length === 0) {
            return `<div class="emk-timeline" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty timeline — add events in the inspector)</div>`;
        }
        const align = props.align ?? "left";
        const accent = props.accent ?? "#111827";
        const text = props.textColor ?? "#0f172a";
        const bg = props.background ?? "transparent";
        const cardBg = props.cardBackground ?? "#ffffff";
        if (align === "alternating") {
            const rows = events
                .map((ev, i) => {
                const left = i % 2 === 0;
                const desc = ev.description
                    ? `<p style="margin:6px 0 0;font-size:14px;line-height:1.55;color:${text};opacity:0.7">${escapeHtml(ev.description)}</p>`
                    : "";
                const card = `<div style="background:${cardBg};border:1px solid rgba(0,0,0,0.08);border-radius:10px;padding:14px 16px;max-width:360px"><div style="font-size:12px;color:${accent};font-weight:600;letter-spacing:0.05em;text-transform:uppercase">${escapeHtml(ev.date)}</div><h3 style="margin:6px 0 0;font-size:16px;font-weight:600;color:${text}">${escapeHtml(ev.title)}</h3>${desc}</div>`;
                const dot = `<div aria-hidden="true" style="width:14px;height:14px;border-radius:50%;background:${accent};box-shadow:0 0 0 4px ${bg === "transparent" ? "#ffffff" : bg};flex-shrink:0;position:relative;z-index:1"></div>`;
                return `<div style="display:grid;grid-template-columns:1fr 28px 1fr;align-items:center;gap:12px">${left ? `<div style="display:flex;justify-content:flex-end">${card}</div>${dot}<div></div>` : `<div></div>${dot}<div style="display:flex;justify-content:flex-start">${card}</div>`}</div>`;
            })
                .join("");
            return `<div class="emk-timeline emk-timeline--alt" style="background:${bg};padding:20px 0;font-family:inherit"><div style="max-width:960px;margin:0 auto;position:relative;display:flex;flex-direction:column;gap:24px"><div aria-hidden="true" style="position:absolute;left:50%;top:0;bottom:0;width:2px;background:${accent};opacity:0.2;transform:translateX(-1px)"></div>${rows}</div></div>`;
        }
        const rows = events
            .map((ev, i) => {
            const last = i === events.length - 1;
            const line = !last
                ? `<div aria-hidden="true" style="position:absolute;left:7px;top:16px;bottom:-24px;width:2px;background:${accent};opacity:0.25"></div>`
                : "";
            const desc = ev.description
                ? `<p style="margin:6px 0 0;font-size:14px;line-height:1.55;color:${text};opacity:0.7">${escapeHtml(ev.description)}</p>`
                : "";
            return `<div style="display:flex;gap:20px;position:relative;padding-bottom:${last ? 0 : 24}px"><div style="flex-shrink:0;width:16px;display:flex;justify-content:center;padding-top:4px;position:relative">${line}<div style="width:16px;height:16px;border-radius:50%;background:${accent};position:relative;z-index:1"></div></div><div style="flex:1"><div style="font-size:12px;color:${accent};font-weight:600;letter-spacing:0.05em;text-transform:uppercase">${escapeHtml(ev.date)}</div><h3 style="margin:4px 0 0;font-size:16px;font-weight:600;color:${text}">${escapeHtml(ev.title)}</h3>${desc}</div></div>`;
        })
            .join("");
        return `<div class="emk-timeline emk-timeline--left" style="background:${bg};padding:20px 0;font-family:inherit"><div style="max-width:720px;margin:0 auto">${rows}</div></div>`;
    },
};
//# sourceMappingURL=timeline.js.map